import { isCodeVerificationSignup, isEmailVerificationSignup } from '../app/verificationTypeSelectors';
export const shouldRequirePassword = state => isEmailVerificationSignup(state) || isCodeVerificationSignup(state);